import { FirebaseApp } from "@firebase/app";
import * as React from "react";
import { firebaseConfig } from "../config";

// firebase component
export const useFirebase = () => {
  // we need to import here for prevent gatsby build error
  const [app, setApp] = React.useState<FirebaseApp | null>(null);
  const [firestore, setFirestore] = React.useState<
    typeof import("firebase/firestore") | null
  >(null);

  React.useEffect(() => {
    // load firebase only if window is set
    if (!app && typeof window !== "undefined") {
      // import
      Promise.all([import("@firebase/app"), import("firebase/firestore")]).then(
        (values) => {
          const app = values[0].initializeApp(firebaseConfig);
          // set firebase objects
          setApp(app);
          setFirestore(values[1]);
        }
      );
    }
  }, []);

  return { app, firestore };
};
